/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import {
  SET_DATE,
  SET_VIEW,
  NEXT_BUTTON,
  SET_CALENDAR_DATA,
  TOGGLE_MODAL,
  SET_SELECTED_EMPLOYEE,
  SET_SELECTED_SERVICE,
  SET_APPOINTMENT_TIME,
  SET_APPOINTMENT_DATE,
  ADMIN_BOOKING_HIDE_MESSAGE,
  ADMIN_BOOKING_SHOW_MESSAGE,
  SET_ADMIN_ALL_EMPLOYEE_SELECTED,
  SET_ADMIN_EMPLOYEE_SELECTED,
  SET_SINGLE_SELECTED_EMPLOYEE,
  CHANGE_ADMIN_LOADER,
  SET_CUSTOMER_LIST,
  SET_SELECTED_CUSTOMER,
  SET_MODAL_INITIATOR,
  SET_APPOINTMENT_STATUS,
  SET_APPOINTMENT_MESSAGE,
  SET_APPOINTMENT_ID,
  SET_CALENDAR_VIEW,
  OPEN_EMPLOYEE_SELECTION,
  SET_MONTHLY_SELECT_EMPLOYEE,
  REMOVE_WORKING_HOURS_EMPLOYEE,
  TOGGLE_CUSTOMER_MODAL,
  CALL_CUSTOMERS_API_RESPONSE,
  CHANGE_CUSTOMER_ADD_STATE,
  ADMIN_BOOK_FAIL_RESPONSE,
  ADMIN_BOOK_REQUEST_CLOSE,
  UPDATE_CUSTOMER_LIST,
  ADMIN_BOOK_APPOINTMENT_RESPONSE,
  EDIT_ADMIN_APPOINTMENT_RESPONSE,
  ADMIN_BOOK_LOADER_SHOW,
  ADMIN_BOOK_LOADER_HIDE,
  ADMIN_BOOK_MAIN_LOADER_SHOW,
  ADMIN_BOOK_MAIN_LOADER_HIDE,
  BULK_EMPLOYEE_CALENDER_RESPONSE,
} from "../constants/ActionTypes";
import moment from "moment";

const initialState = {
  selectedDate: new Date(),
  minTime: 9,
  maxTime: 17,
  resources: [],
  events: [],
  employees: [],
  modalState: false,
  selectedEmployee: "",
  selectedServices: [],
  selectedEmployeeData: [],
  selectedResourcesData: [],
  selectedEventsData: [],
  price: 0,
  duration: 0,
  selectedService: "",
  appointmentDate: "",
  appointmentTime: "12:30 am",
  loader: false,
  customerList: [],
  selectedCustomer: "",
  selectedCustomerData: {},
  viewCustomer: false,
  modalInitiate: "",
  appointmentStatus: "",
  message: "",
  appointmentId: "",
  calendarView: "day",
  nextButton: false,
  employeeSelectionModal: false,
  monthlySelectedEmployee: "",
  workingHoursEmployees: [],
  toggleCustomer: false,
  customerAdd: false,
  showMessage: false,
  errorMessage: false,
  alertMessage: "",
  operations: {},
  adminBookLoader: false,
  mainLoader: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DATE: {
      return {
        ...state,
        selectedDate: payload,
      };
    }
    case SET_VIEW: {
      return {
        ...state,
        calendarView: "day",
      };
    }
    case NEXT_BUTTON: {
      return {
        ...state,
        nextButton: true,
      };
    }
    case SET_CALENDAR_DATA: {
      const { setCurrentDate, data } = payload;
      const d1 = new Date();
      const year = d1.getFullYear();
      const month = d1.getMonth();
      const date = d1.getDate();
      const date1 = new Date(year, month, date);
      let minTime = moment({ hours: 23, minutes: 59 });
      let maxTime = moment({ hours: 0, minutes: 0 });

      Object.values(data.operations).forEach(element => {
        const from = `${moment().format("YYYY-MM-DD")} ${element.from}`;
        const to = `${moment().format("YYYY-MM-DD")} ${element.to}`;

        if (moment(minTime).isAfter(moment(from), "minutes")) {
          minTime = from;
        }

        if (moment(maxTime).isBefore(moment(to), "minutes")) {
          maxTime = to;
        }
      });

      minTime = moment(minTime).hours();

      maxTime = moment(maxTime).hours();
      return {
        ...state,
        events: data.events,
        resources: data.resources,
        employees: data.employees_working,
        // minTime: Object.values(data.operations)[0]
        //   .from.split(":")[0]
        //   .replace(/^0+/, ""),
        // maxTime: Object.values(data.operations)[0]
        //   .to.split(":")[0]
        //   .replace(/^0+/, ""),
        minTime,
        maxTime,
        selectedEmployee: "",
        selectedServices: [],
        selectedService: "",
        selectedDate: setCurrentDate ? date1 : state.selectedDate,
        price: 0,
        duration: 0,
        selectedEmployeeData: Object.keys(state.selectedEmployeeData).length == 0 ? data.selectedEmployees.map(item => item._id) : state.selectedEmployeeData,
        selectedResourcesData: data.selectedResources,
        selectedEventsData: data.selectedEvents,
        workingHoursEmployees: data.selectedEmployees,
        operations: data.operations,
        closures: data.closures,
        mainLoader: false,
      };
    }
    case TOGGLE_MODAL: {
      return {
        ...state,
        modalState: payload,
      };
    }
    case SET_SELECTED_EMPLOYEE: {
      return {
        ...state,
        selectedEmployee: payload.id,
        selectedServices: payload.services,
        selectedService: payload.service,
        price: payload.service_price,
        duration: payload.service_duration,
      };
    }
    case SET_SELECTED_SERVICE: {
      return {
        ...state,
        selectedService: payload.id,
        price: payload.service_details_price,
        duration: payload.service_details_duration,
      };
    }
    case SET_APPOINTMENT_DATE: {
      return {
        ...state,
        appointmentDate: payload,
      };
    }
    case SET_APPOINTMENT_TIME: {
      return {
        ...state,
        appointmentTime: payload,
      };
    }
    case SET_APPOINTMENT_ID: {
      return {
        ...state,
        appointmentId: payload,
      };
    }
    case SET_CALENDAR_VIEW: {
      return {
        ...state,
        calendarView: payload,
      };
    }
    case CHANGE_ADMIN_LOADER:
      return { ...state, loader: payload };

    case ADMIN_BOOKING_SHOW_MESSAGE: {
      const alertMessage =
        state.modalInitiate !== "event"
          ? "vibo.notification.appointmentBooked"
          : "vibo.notification.appointmentModified";
      return { ...state, showMessage: true, alertMessage };
    }

    // case ADMIN_BOOKING_HIDE_MESSAGE:
    //   return { ...state, showMessage: false, alertMessage: "" };
    case SET_ADMIN_ALL_EMPLOYEE_SELECTED: {
      const ans = state.employees.length === state.selectedEmployeeData.length;

      return {
        ...state,
        selectedEventsData: ans ? [] : state.events,
        selectedResourcesData: ans ? [] : state.resources,
        selectedEmployeeData: ans ? [] : state.employees.map(employee => employee._id),
        workingHoursEmployees: ans ? [] : state.employees,
      };
    }
    case SET_ADMIN_EMPLOYEE_SELECTED: {
      if (state.selectedEmployeeData.indexOf(payload) > -1) {
        return {
          ...state,
          selectedEmployeeData: state.selectedEmployeeData.filter(item => item !== payload),
          selectedResourcesData: state.selectedResourcesData.filter(
            item => item.resourceId !== payload
          ),
          selectedEventsData: state.selectedEventsData.filter(item => item.resourceId !== payload),
          workingHoursEmployees: state.workingHoursEmployees.filter(item => item._id !== payload),
        };
      }

      return {
        ...state,
        selectedEmployeeData: [...state.selectedEmployeeData, payload],
        selectedResourcesData: [
          ...state.selectedResourcesData,
          ...state.resources.filter(item => item.resourceId === payload),
        ],
        selectedEventsData: [
          ...state.selectedEventsData,
          ...state.events.filter(item => item.resourceId === payload),
        ],
        workingHoursEmployees: [
          ...state.workingHoursEmployees,
          ...state.employees.filter(item => item._id === payload),
        ],
      };
    }
    case SET_SINGLE_SELECTED_EMPLOYEE: {
      return {
        ...state,
        selectedEmployeeData: [payload],
        selectedResourcesData: [...state.resources.filter(item => item.resourceId === payload)],
        selectedEventsData: [...state.events.filter(item => item.resourceId === payload)],
        workingHoursEmployees: [...state.employees.filter(item => item._id === payload)],
      };
    }
    case SET_CUSTOMER_LIST: {
      return {
        ...state,
        customerList: payload,
      };
    }
    case UPDATE_CUSTOMER_LIST: {
      let { viewCustomer, customerList, selectedCustomerData } = state;

      if (viewCustomer) {
        customerList = customerList.map(item => {
          if (item._id === payload._id) {
            item = payload;
            selectedCustomerData = payload;
          }

          return item;
        });
      }

      return {
        ...state,
        customerList,
        selectedCustomerData,
      };
    }
    case SET_SELECTED_CUSTOMER: {
      console.log("TCL: payload", payload)
      return {
        ...state,
        selectedCustomer: payload.primary_details ? payload.primary_details.firstname + " " + payload.primary_details.lastname : payload,
        selectedCustomerData: payload,
        viewCustomer: !!(payload || payload.primary_details),
      };
    }
    case SET_MODAL_INITIATOR: {
      return {
        ...state,
        modalInitiate: payload,
      };
    }
    case SET_APPOINTMENT_STATUS: {
      return {
        ...state,
        appointmentStatus: payload,
      };
    }
    case SET_APPOINTMENT_MESSAGE: {
      return {
        ...state,
        message: payload,
      };
    }
    case OPEN_EMPLOYEE_SELECTION: {
      return {
        ...state,
        employeeSelectionModal: !state.employeeSelectionModal,
      };
    }
    case SET_MONTHLY_SELECT_EMPLOYEE: {
      return {
        ...state,
        monthlySelectedEmployee: payload,
      };
    }

    case REMOVE_WORKING_HOURS_EMPLOYEE:
      return {
        ...state,
        workingHoursEmployees: state.workingHoursEmployees.filter(item => item._id !== payload),
      };

    case TOGGLE_CUSTOMER_MODAL:
      return { ...state, toggleCustomer: payload };

    case CALL_CUSTOMERS_API_RESPONSE:
      return { ...state, customerAdd: false, customerList: payload };

    case CHANGE_CUSTOMER_ADD_STATE:
      return { ...state, customerAdd: payload };

    case ADMIN_BOOK_FAIL_RESPONSE:
      return { ...state, errorMessage: true, alertMessage: payload };

    case ADMIN_BOOK_REQUEST_CLOSE:
      return { ...state, errorMessage: false, showMessage: false };

    case ADMIN_BOOK_APPOINTMENT_RESPONSE: {
      return {
        ...state,
        events: [...state.events, payload],
        selectedEventsData: [...state.selectedEventsData, payload],
        selectedCustomer: "",
        selectedCustomerData: {},
        viewCustomer: false,
      };
    }

    case EDIT_ADMIN_APPOINTMENT_RESPONSE: {
      const { myObject, appointmentId } = payload;
      let { selectedEventsData } = state;
      selectedEventsData = selectedEventsData.filter(item => item.id !== appointmentId);
      return {
        ...state,
        events: [...state.events, myObject],
        selectedEventsData: [...selectedEventsData, myObject],
        selectedCustomer: "",
        selectedCustomerData: {},
        viewCustomer: false,
      };
    }

    case ADMIN_BOOK_LOADER_SHOW:
      return { ...state, adminBookLoader: true };

    case ADMIN_BOOK_LOADER_HIDE:
      return { ...state, adminBookLoader: false };

    case ADMIN_BOOK_MAIN_LOADER_SHOW:
      return { ...state, mainLoader: true };

    case BULK_EMPLOYEE_CALENDER_RESPONSE: {
      const { workingHoursEmployees } = state;

      const { finalAddEmployeesData, finalEditEmployeesData } = payload;

      workingHoursEmployees.forEach(item => {
        finalAddEmployeesData.forEach(item1 => {
          if (item1.employee._id === item._id) {
            const { _id, from, to, entryType } = item1;
            let { employee } = item1;
            employee = employee._id;

            item.schedule.push({ employee, _id, from, to, entryType });
          }
        });

        finalEditEmployeesData.forEach(item1 => {
          if (item1.employee._id === item._id) {
            const { _id, from, to, entryType } = item1;

            item.schedule.forEach(item2 => {
              if (item2._id === _id) {
                item2 = {
                  _id,
                  from,
                  to,
                  entryType,
                };
              }
            });
          }
        });
      });

      return { ...state, workingHoursEmployees };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/AdminBookAppointment.js